// src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
  verify: () => api.get('/auth/verify'),
};

export const fruitsAPI = {
  getAll: (params) => api.get('/fruits', { params }),
  getById: (id) => api.get(`/fruits/${id}`),
  getCategories: () => api.get('/fruits/categories'),
};

export const enquiryAPI = {
  create: (data) => api.post('/enquiry/create', data),
  getUserEnquiries: () => api.get('/enquiry/user'),
  getById: (id) => api.get(`/enquiry/${id}`),
};

export const chatAPI = {
  getMessages: (enquiryId) => api.get(`/chat/${enquiryId}`),
  sendMessage: (enquiryId, formData) => api.post(`/chat/${enquiryId}/send`, formData),
};

export const verificationAPI = {
  submit: (formData) => api.post('/verification/submit', formData),
  getStatus: () => api.get('/verification/status'),
};

export const paymentAPI = {
  getPayments: (enquiryId) => api.get(`/payment/enquiry/${enquiryId}`),
  submit: (formData) => api.post('/payment/submit', formData),
};

export const shippingAPI = {
  getShipment: (enquiryId) => api.get(`/shipping/enquiry/${enquiryId}`),
};

export const adminAPI = {
  // Dashboard
  getDashboard: () => api.get('/admin/dashboard'),
  
  // Fruits
  getAllFruits: () => api.get('/admin/fruits'),
  createFruit: (formData) => api.post('/admin/fruits/create', formData),
  updateFruit: (id, formData) => api.put(`/admin/fruits/${id}`, formData),
  deleteFruit: (id) => api.delete(`/admin/fruits/${id}`),
  
  // Enquiries
  getAllEnquiries: () => api.get('/admin/enquiries'),
  updateEnquiryStatus: (id, data) => api.put(`/admin/enquiries/${id}/status`, data),
  
  // Payments
  getAllPayments: () => api.get('/admin/payments'),
  verifyPayment: (id, data) => api.post(`/admin/payments/${id}/verify`, data),
  
  // Verifications
  getAllVerifications: () => api.get('/admin/verifications'),
  verifyBuyer: (id, data) => api.post(`/admin/verifications/${id}/verify`, data),
  
  // Shipments
  getAllShipments: () => api.get('/admin/shipments'),
  updateShipment: (data) => api.post('/admin/shipments/update', data),
  
  // Users
  getAllUsers: () => api.get('/admin/users'),
};

export default api;